module.exports = __webpack_public_path__ + "static/btn_046.5c58803e.png";